import React, { useEffect, useContext, useState, useRef } from 'react';


export default function UI_Image({
    style,
    className,
    id,
    src,
    alt,
    Fill,
    Fit,
    Conform_Container = false,
    onClick,
    children,
    onLoad
}) {

    const [isLoaded, setIsLoaded] = useState(false);
    const Reference_Shimmer = useRef(null);
    const Reference_Image = useRef(null);

    const Handle_Loaded = () => {
        setIsLoaded(true);

        if (Reference_Image.current && onLoad) {
            const dimensions = {
                width: Reference_Image.current.naturalWidth,
                height: Reference_Image.current.naturalHeight,
                renderedWidth: Reference_Image.current.offsetWidth,
                renderedHeight: Reference_Image.current.offsetHeight
            };

            onLoad(dimensions);
        }
    };

    useEffect(() => {
        setIsLoaded(false);
        const img = new Image();
        img.src = src;
        img.onload = Handle_Loaded;
    }, [src]);
    return (
        <>
            <div
                className="General_Image"
                Image_Fill={Fill ? "Fill" : ""}
                Conform_Container={Conform_Container ? "Conform" : undefined}
                style={style}
            >
                {!isLoaded ?
                    <div className="General_Image_Loader"></div>
                    :
                    ""
                }
                <img
                    className={className ? className : ""}
                    ref={Reference_Image}
                    src={src}
                    draggable='false'
                    loading='lazy'
                    onLoad={Handle_Loaded}
                    alt={alt}
                    id={id}
                    onClick={onClick}
                    Image_Fill={Fill ? "Fill" : ""}
                    Fit={Fit ? "Fit" : ""}
                    Visibility={isLoaded ? "Visible" : "Hidden"}
                />
                {children}
            </div>

        </>

    )
}